import { Loader } from '@mobalytics/shared';
import { CheckoutProvider } from '@stripe/react-stripe-js/checkout';
import * as React from 'react';
import type { Appearance } from '@stripe/stripe-js';
import { TreasuryPaymentsProvider } from '../../../../../__generated/treasury/types';
import { getStripePromise } from '../../../../payment/payment.component';
import { ProductI } from '../../../payment.types';
import { usePaymentFlowCheckout } from '../use-payment-flow-checkout.hook';
import { StripeCheckoutForm } from './stripe-checkout-form.component';

interface Props {
  className?: string;
  product: ProductI;
  submitButtonLabel: string;
  isBundleAdded: boolean;
  paypalButton?: React.ReactNode;
}

export const StripeFlow: React.FC<Props> = (props) => {
  const { product, submitButtonLabel, isBundleAdded, paypalButton } = props;

  const {
    price: { id: priceId },
  } = product;

  const data = usePaymentFlowCheckout(TreasuryPaymentsProvider.STRIPE);
  const { status, checkout } = data;

  React.useEffect(() => {
    if (priceId) {
      // todo: check that it is not fired more then once
      if (product.__typename === 'TreasuryProductBattlePass') {
        const { planId = null, coupon = null } = product.bundle || {};
        checkout([{ priceId }], planId && isBundleAdded ? { planId, coupon } : undefined);
      }
      if (product.__typename === 'TreasuryProductXPBooster') {
        checkout([{ priceId }], undefined);
      }
    }
  }, [checkout, isBundleAdded, priceId, product.__typename, product]);

  if (status === 'loading') {
    return <Loader />;
  }
  if (status === 'error') {
    return <div>Error: {data.errorMessage}</div>;
  }

  const { clientSecret } = data;

  return (
    <CheckoutProvider
      stripe={getStripePromise()}
      options={{
        clientSecret,
        elementsOptions: {
          appearance,
        },
      }}
    >
      <StripeCheckoutForm
        productId={product.id}
        priceId={priceId}
        submitButtonLabel={submitButtonLabel}
        paypalButton={paypalButton}
      />
    </CheckoutProvider>
  );
};

const appearance: Appearance = {
  variables: {
    colorPrimary: '#f2bf43',
    colorText: '#fff',
    colorTextSecondary: '#6b6889',
    colorBackground: '#211d41',
    colorTextPlaceholder: '#6b6889',
    colorDanger: '#E54787',
    fontFamily: 'Roboto, sans-serif',
  },
  rules: {
    '.Label': {
      color: '#8890b5',
    },
    '.AccordionItem': {
      color: '#fff',
    },
    '.Input:focus': {
      boxShadow: 'none',
      borderColor: '#f2bf43',
    },
  },
};
